import { useDefaultWatchlistRoute } from '@unistocks/features/watchlists/use-route';
import { Redirect } from 'expo-router';

export default function WatchlistsScreen() {
  const href = useDefaultWatchlistRoute();

  return <Redirect withAnchor href={href} />;
}
